export default __webpack_public_path__ + "static/media/Arrow_Order_Down.989b6403.svg";